<template>
  <div>
    <div class="content">
      <div class="contentLeft">
        <div class="inpCont">
          <div class="inpBox">
            <input
              type="text"
              placeholder="搜索联系人姓名"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
            <div
              class="iconfont icon-search seach dis-cent"
              @click="searchClick"
            ></div>
          </div>
        </div>
        <div class="ggCont">
          <div class="box">
            <div class="iconfont icon-systemprompt"></div>
            <div class="text">警惕诈骗，保护财产！</div>
          </div>
        </div>
        <div class="cont">
          <Kong v-if="peolist.length == 0" />
          <div
            class="contLi"
            :class="item.to_id == id ? 'on' : ''"
            v-for="(item, index) in peolist"
            @click="peoClick(item, index)"
          >
            <div class="img">
              <img :src="$imgUrl + item.to_avatar" alt="" />
            </div>
            <div class="box">
              <div class="titleBox">
                <div class="name">
                  {{ item.to_name }}
                </div>
                <div class="num dis-cent" v-if="item.not_read_num != 0">
                  {{ item.not_read_num }}
                </div>
                <!-- <div class="textBox">
                  <div class="text c-1">公司</div>
                  <div class="shu"></div>
                  <div class="text c-1">程序开发</div>
                </div> -->
              </div>
              <div class="txtBox">
                <div class="name c-1">
                  {{
                    item.last_chat_content ? item.last_chat_content : "暂无信息"
                  }}
                </div>
                <div class="time">{{ item.time }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contentRit">
        <div class="zanwu" v-if="!id">
          <div class="img">
            <img src="../../assets/img/xxzanwu.png" alt="" />
          </div>
          <div class="text">与您进行过沟通的人都会在左侧列表中显示</div>
        </div>
        <div class="headBox" v-if="id">
          <div class="box">
            <div class="text">{{ info.to_name }}</div>
            <div class="shu"></div>
            <div class="text">{{ info.company.name }}</div>
            <div class="shu"></div>
            <div class="text">{{ info.company.trade_cn }}</div>
          </div>
          <div class="btn dis-cent" @click="msClick">面试申请</div>
        </div>
        <div class="jobBox" v-if="info.job_id" @click="jobClick(info.job_id)">
          <div class="name">{{ info.job.jobs_name }}</div>
          <div class="shu"></div>
          <div class="money">
            {{
              info.job.minwage == 0 && info.job.maxwage == 0
                ? "面议"
                : info.job.minwage + "-" + info.job.maxwage + "K"
            }}
          </div>
          <div class="shu"></div>
          <div class="txt">{{ info.job.district_cn }}</div>
        </div>
        <div
          class="jobBox"
          @click="oddClick(info.odd_id)"
          v-else-if="info.odd_id"
        >
          <div class="name">{{ info.odd.name }}</div>
          <div class="shu"></div>
          <div class="money">
            {{ info.odd.price }} 元/{{ info.odd.way == 1 ? "件" : "小时" }} ·
            {{
              info.odd.result == 1
                ? "日结"
                : info.odd.result == 2
                ? "周结"
                : "月结"
            }}
          </div>
          <div class="shu"></div>
          <div class="txt">{{ info.odd.linggong }}</div>
        </div>
        <div class="contBox scroll" v-if="id" @scroll="handleScroll">
          <div
            class="cont"
            :class="item.from_id == com_id ? 'contr' : ''"
            v-for="(item, index) in list"
            :id="'list' + (index + 1)"
          >
            <div
              class="box"
              :class="item.from_id == com_id ? 'boxr' : 'boxl'"
              v-if="item.type == 'text'"
            >
              {{ item.content }}
            </div>
            <div
              class="img"
              v-if="item.type == 'img'"
              @click="ImgBig(item.content)"
            >
              <img :src="$imgUrl + item.content" alt="" />
            </div>
            <div class="jlCont" v-if="item.type == 'resume'">
              <div class="jlBox">
                <div class="icon iconfont icon-xinwen dis-cent"></div>
                <div class="name">{{ msinfo.realname }}的简历信息</div>
              </div>
              <div class="jlBtn dis-cent" @click="jlContClick">
                点击查看简历
              </div>
            </div>
            <div class="jlCont" v-if="item.type == 'telnum'">
              <div class="jlBox">
                <div class="icon iconfont icon-xinwen dis-cent"></div>
                <div class="txtBox">
                  <div class="name">{{ msinfo.realname }}的电话:</div>
                  <div class="name">{{ item.content }}</div>
                </div>
              </div>
              <div class="jlBtn dis-cent" @click="tleClick(item.content)">
                点击复制电话
              </div>
            </div>
            <div class="jlCont" v-if="item.type == 'wechat'">
              <div class="jlBox">
                <div class="icon iconfont icon-xinwen dis-cent"></div>
                <div class="txtBox">
                  <div class="name">{{ msinfo.realname }}的微信号:</div>
                  <div class="name">{{ item.content }}</div>
                </div>
              </div>
              <div class="jlBtn dis-cent" @click="tleClick(item.content)">
                点击复制微信号
              </div>
            </div>
            <div class="jlCont" v-if="item.type == 'interview'">
              <div class="jlBox">
                <div class="icon iconfont icon-xinwen dis-cent"></div>
                <div class="txtBox">
                  <div class="name">
                    <div
                      v-if="
                        item.interview.censoring == 3 ||
                        item.interview.censoring == -1
                      "
                    >
                      面试{{
                        item.interview.censoring == 3 ? "已同意" : "已拒绝"
                      }}
                    </div>
                    <div
                      v-if="
                        item.interview.censoring == 1 ||
                        item.interview.censoring == 2
                      "
                    >
                      {{ item.interview.pd == 1 ? "面试未同意" : "面试已超时" }}
                    </div>
                  </div>
                  <div class="name">{{ item.interview.starttime }}</div>
                </div>
              </div>
              <div class="jlBtn dis-cent" @click="msContJs(item.interview.id)">
                点击查看详情
              </div>
            </div>
            <div class="time">{{ item.time }}</div>
          </div>
        </div>
        <div class="contBtn" v-if="id">
          <div class="box">
            <div
              class="iconfont icon-picture picture"
              @click="uploadFile"
            ></div>
            <div class="shu"></div>
            <div class="textBox dis-cent">
              <a-popconfirm
                title="是否发送简历"
                ok-text="是"
                cancel-text="否"
                @confirm="jlconfirm"
              >
                发简历
              </a-popconfirm>
            </div>
            <div class="textBox dis-cent">
              <a-popconfirm
                title="是否发送手机号码"
                ok-text="是"
                cancel-text="否"
                @confirm="confirm"
              >
                发电话
              </a-popconfirm>
            </div>
            <div class="textBox dis-cent">
              <a-popconfirm
                title="是否发送微信"
                ok-text="是"
                cancel-text="否"
                @confirm="wxConfirm"
              >
                发微信
              </a-popconfirm>
            </div>
          </div>
          <div class="cont">
            <textarea v-model="content" @keydown="search2($event)"></textarea>
          </div>
          <div class="funBox">
            <div class="text">按Enter键发送</div>
            <div
              class="btn dis-cent"
              :class="content ? 'on' : ''"
              @click="search"
            >
              发送
            </div>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      accept="image/*"
      ref="fileInput"
      @change="onFileChange"
      style="display: none"
    />
    <Jianli v-if="jlShow" type="1" :id="peoId" @show="jlShowJs" />
    <a-modal
      v-model="visible"
      title="提示"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>
        {{
          tcType == 1
            ? "未填写手机号码，是否前往完善"
            : tcType == 2
            ? "未填写微信，是否前往完善"
            : tcType == 3
            ? "未填写简历，是否前往完善"
            : ""
        }}
      </p>
    </a-modal>
    <Mianshi
      :member_info="msinfo"
      :job_id="info.job_id"
      :odd_id="info.odd_id"
      :lxType="lxType"
      :to_id="info.to_id"
      type="1"
      v-if="msShow"
      @show="msShowJs"
    />
    <MsCont v-if="msContShow" :id="msContId" @show="msContShow = false" />
    <ImgBig
      @del="imgDelClick"
      :list="imgList"
      :index="imgIndex"
      v-if="imgShow"
    />
  </div>
</template>

<script>
import WebSocketInit from "@/assets/js/wxb";
import Kong from "../component/kong.vue";
import Jianli from "../component/jianli.vue";
import { Popconfirm, Modal } from "ant-design-vue";
import Mianshi from "../component/mianshi.vue";
import MsCont from "../component/msCont.vue";
import ImgBig from "../component/imgBig.vue";
export default {
  components: {
    Kong,
    Jianli,
    Mianshi,
    MsCont,
    ImgBig,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      msContId: 0,
      msContShow: false,
      msShow: false,
      tcType: 0,
      visible: false,
      jlShow: false,
      content: "",
      com_id: "",
      peojudge: true,
      peopage: {
        pageNo: 1,
        pageSize: 30,
      },
      peolist: [],
      peototalCount: 0,
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 15,
        odb: "a.id desc",
      },
      list: [],
      totalCount: 0,
      id: "",
      info: {
        company: {},
        job: {},
      },
      wsJz: 0,
      change: 0,
      member_info: {},
      msinfo: {},
      lxType: 0,
      searChTxt: "",
      peoId: 0,
      imgIndex: 0,
      imgList: [],
      imgShow: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.duankai = window.localStorage.setItem("duankai", "2");
    this.infoGet();
    this.get();
    this.peoListGet();
  },
  destroyed() {
    this.duankai = window.localStorage.setItem("duankai", "1");
    window.ws1.close();
  },
  methods: {
    jobClick(id) {
      // this.$router.push({
      //   path: "/jobCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/jobCont?id=" + id);
    },
    oddClick(id) {
      // this.$router.push({
      //   path: "/ligGzCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/ligGzCont?id=" + id);
    },
    ImgBig(url) {
      let index = 0;
      let imgs = [];
      for (let i = 0; i < this.list.length; i++) {
        const e = this.list[i];
        if (e.type == "img") {
          imgs.push({
            path_name: e.content,
          });
        }
      }
      for (let i = 0; i < imgs.length; i++) {
        const e = imgs[i];
        if (e.path_name == url) {
          index = i;
        }
      }
      this.imgIndex = index;
      this.imgList = imgs;
      this.imgShow = true;
    },
    imgDelClick() {
      this.imgShow = false;
    },
    handleScroll(event) {
      // 当滚动条的位置超过0时，isTop为false
      let isTop = event.target.scrollTop <= 0;
      if (isTop) {
        this.listGet(1);
      }
    },
    searchClick() {
      this.peopage.name = this.searChTxt;
      this.peopage.pageNo = 1;
      this.totalCount = 0;
      this.peolist = [];
      this.peoListGet();
    },
    msContJs(id) {
      this.msContShow = true;
      this.msContId = id;
    },
    msContJump() {},
    jlContClick() {
      this.jlShow = true;
      this.peoId = this.com_id;
    },
    jlShowJs() {
      this.jlShow = false;
    },
    msClick() {
      this.msShow = true;
    },
    msShowJs(value) {
      console.log(value);
      if (value) {
        let data = {
          type: "message",
          sender: this.com_id + "",
          sender_type: "2",
          recipient: this.id + "",
          recipient_type: "1",
          content: value.id + "",
          content_type: "interview",
          device: "mobile",
        };
        window.ws1.send(JSON.stringify(data));
      }
      this.msShow = false;
    },
    tleClick(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    peoListGet() {
      if (!this.peojudge) {
        return;
      }
      this.peojudge = false;
      this.$get("/chat/chat_list", this.peopage).then((res) => {
        this.peojudge = true;
        if (res.data) {
          if (this.id) {
            this.info = res.data[0];
            this.lxType = this.info.job_id ? "1" : "2";
            this.job_id = this.info.job_id;
            this.odd_id = this.info.odd_id;
            this.page.chat_uuid = res.data[0].uuid;
            this.numGet(res.data[0].to_id);
            this.listGet();
          }
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.time = this.$moment(e.last_chat_time).format("M/D HH:mm");
            if (e.type == "interview") {
              e.interview.pd = this.timeDb(e.interview.start_time);
            }
            this.peolist.push(e);
          }
        }
      });
    },
    peoClick(item, i) {
      console.log(item);
      this.info = item;
      this.lxType = this.info.job_id ? "1" : "2";
      this.job_id = this.info.job_id;
      this.odd_id = this.info.odd_id;
      this.page.chat_uuid = item.uuid;
      this.id = item.to_id;
      this.page.pageNo = 1;
      this.list = [];
      this.peolist[i].not_read_num = 0;
      this.numGet(item.to_id);
      this.listGet();
    },
    numGet(id) {
      this.$post("/chat/chat_message_read", {
        from_id: id,
      }).then((res) => {});
    },
    listGet(type) {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/chat/chat_message", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.time = this.$moment(e.create_time).format("M/D HH:mm");
            if (e.type == "interview") {
              e.interview.pd = this.timeDb(e.interview.start_time);
            }
            this.list.unshift(e);
          }
          if (type != 1) {
            setTimeout(() => {
              document
                .getElementById("list" + this.list.length)
                .scrollIntoView({ behavior: "auto" });
            }, 50);
          } else {
            setTimeout(() => {
              document
                .getElementById("list" + 15)
                .scrollIntoView({ behavior: "auto" });
            }, 50);
          }
          this.page.pageNo++;
        }else{
          let data = {
            type: "message",
            sender: this.com_id + "",
            sender_type: "2",
            recipient: this.id + "",
            recipient_type: "1",
            content: '您好，岗位还招人吗？',
            content_type: "text",
            device: "mobile",
          };
          window.ws1.send(JSON.stringify(data));
        }
      });
    },
    timeDb(time2) {
      console.log(time2);
      // 创建两个时间对象
      const time1 = this.$moment();
      time2 = this.$moment(time2);
      // 比较时间
      let pd = 0;
      if (time1.isBefore(time2)) {
        pd = 1;
      } else if (time1.isAfter(time2)) {
        pd = 2;
      } else {
        pd = 3;
      }
      return pd;
    },
    get() {},
    search() {
      let data = {
        type: "message",
        sender: this.com_id + "",
        sender_type: "2",
        recipient: this.id + "",
        recipient_type: "1",
        content: this.content,
        content_type: "text",
        device: "mobile",
      };
      window.ws1.send(JSON.stringify(data));
      this.content = "";
    },
    search2(ev) {
      if (ev.keyCode == 13) {
        //键盘回车的编码是13
        event.preventDefault();
        this.search();
        return false;
      }
    },
    uploadFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgSearch(res.data.data.path_name);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    imgSearch(img) {
      let data = {
        type: "message",
        sender: this.com_id + "",
        sender_type: "2",
        recipient: this.id + "",
        recipient_type: "1",
        content: img,
        content_type: "img",
        device: "mobile",
      };
      window.ws1.send(JSON.stringify(data));
    },
    infoGet() {
      this.$get("/nozzle/web/member_ws_info").then((res) => {
        console.log(res.data);
        if (res.data.id) {
          this.com_id = res.data.id;
          this.member_info = res.data;
          this.msinfo = res.data.member_info;
          this.WebSocketGet();
        }
      });
    },
    jlconfirm() {
      if (this.msinfo.complete_percent < 60) {
        this.tcType = 3;
        this.visible = true;
        return;
      } else {
        let data = {
          type: "message",
          sender: this.com_id + "",
          sender_type: "2",
          recipient: this.id + "",
          recipient_type: "1",
          content: "",
          content_type: "resume",
          device: "mobile",
        };
        window.ws1.send(JSON.stringify(data));
      }
    },
    confirm() {
      if (!this.msinfo.phone) {
        this.tcType = 1;
        this.visible = true;
      } else {
        let data = {
          type: "message",
          sender: this.com_id + "",
          sender_type: "2",
          recipient: this.id + "",
          recipient_type: "1",
          content: this.msinfo.phone,
          content_type: "telnum",
          device: "mobile",
        };
        window.ws1.send(JSON.stringify(data));
      }
    },
    wxConfirm() {
      if (!this.msinfo.weixin) {
        this.tcType = 2;
        this.visible = true;
        return;
      } else {
        let data = {
          type: "message",
          sender: this.com_id + "",
          sender_type: "2",
          recipient: this.id + "",
          recipient_type: "1",
          content: this.msinfo.weixin,
          content_type: "wechat",
          device: "mobile",
        };
        window.ws1.send(JSON.stringify(data));
      }
    },
    handleOk() {
      this.visible = false;
      if (this.tcType == 3) {
        // this.$message.success("请前往个人中心完善简历");
        this.$router.push({
          path: "/jianli",
        });
      } else {
        this.$router.push({
          path: "/jianli",
        });
      }
    },
    WebSocketGet() {
      WebSocketInit("/ws/handler?uid=" + this.com_id + "&utype=2&device=web");
      const getsocketData = (e) => {
        // 创建接收消息函数
        const data = e && e.detail.data;
        if (data.status == 1) {
          this.wsJz = 1;
        }
        if (typeof data.data == "object") {
          this.changeGet(data.sender_data);
          data.data.time = this.$moment(data.data.create_time).format(
            "M/D HH:mm"
          );
          if (data.data.type == "interview") {
            data.data.interview.pd = this.timeDb(
              data.data.interview.start_time
            );
            // data.data.interview.start_time = this.$moment(
            //   data.data.interview.start_time
            // ).format("YYYY年M月D日 HH:mm");
          }
          this.list.push(data.data);
          setTimeout(() => {
            document
              .getElementById("list" + this.list.length)
              .scrollIntoView({ behavior: "auto" });
          }, 50);
        }
      };
      // // 注册监听事件
      window.addEventListener("onmessageWS", getsocketData);
    },
    changeGet(item) {
      for (let i = 0; i < this.peolist.length; i++) {
        const e = this.peolist[i];
        if (e.uuid == item.uuid) {
          this.peolist[i].last_chat_content = item.last_chat_content;
        }
        if (e.to_id == item.to_id) {
          if (item.to_id != this.id) {
            this.peolist[i].not_read_num++;
          } else {
            this.numGet(item.to_id);
          }
        }
      }
    },
    getsocketResult(data) {
      console.log(data, "后端返回的信息");
    },
    // 调用方法传入参数,发送socket信息
    websocketSend(data) {
      this.$socketApi.sendSock(data);
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  height: calc(100vh - 85px);
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  display: flex;
  .contentLeft {
    width: 400px;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .inpCont {
      background: linear-gradient(90deg, #f5fafc, #fcfbfa);
      height: 55px;
      padding: 10px 20px;
      box-sizing: border-box;
      .inpBox {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border: 1px solid #ebebeb;
        border-radius: 5px;
        background-color: #fff;
        display: flex;
        overflow: hidden;
        padding-left: 15px;
        input {
          height: 100%;
          width: calc(100% - 35px);
          font-size: 13px;
        }
        .seach {
          width: 35px;
          height: 35px;
          font-size: 20px;
          color: #9c9c9c;
        }
      }
    }
    .ggCont {
      height: 50px;
      box-sizing: border-box;
      padding: 10px 10px 0;
      .box {
        background-color: #deebf7;
        height: 100%;
        border-radius: 10px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        color: #147ee0;
        .iconfont {
          font-size: 20px;
          width: 30px;
        }
        .text {
          width: calc(100% - 30px);
        }
      }
    }
    .cont {
      height: calc(100% - 55px);
      overflow: auto;
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      .contLi {
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        cursor: pointer;
        border-radius: 5px;
        .img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
        .box {
          padding-left: 15px;
          width: calc(100% - 50px);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .titleBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 16px;
              font-weight: 500;
            }
            .num {
              font-size: 12px;
              background-color: #f3160e;
              color: #fff;
              border-radius: 50%;
              width: 18px;
              height: 18px;
            }
            .textBox {
              display: flex;
              align-items: center;
              margin-left: 10px;
              color: #2c3341;
              .shu {
                width: 1px;
                height: 13px;
                margin: 0 8px;
                background-color: #ebebeb;
              }
            }
          }
          .txtBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #9c9c9c;
            .name {
              width: calc(100% - 80px);
            }
            .time {
              width: 80px;
              font-size: 12px;
              text-align: right;
            }
          }
        }
      }
      .contLi:hover {
        background-color: #f5fafc;
      }
      .on {
        background-color: #f5fafc;
      }
    }
  }
  .contentRit {
    width: calc(100% - 415px);
    margin-left: 15px;
    height: 100%;
    border-radius: 10px;
    background-color: #fff;
    .zanwu {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .img {
        width: 130px;
      }
      .text {
        margin-top: 20px;
        font-size: 13px;
      }
    }
    .headBox {
      height: 55px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      color: #2d3546;
      justify-content: space-between;
      border-bottom: 1px solid whitesmoke;
      .box {
        display: flex;
        align-items: center;
        .shu {
          width: 1px;
          height: 13px;
          margin: 0 8px;
          background-color: #ebebeb;
        }
      }
      .btn {
        border-radius: 5px;
        background-color: #147ee0;
        color: #fff;
        height: 30px;
        width: 80px;
        cursor: pointer;
      }
    }
    .jobBox {
      margin: 0 10px;
      height: 60px;
      border-radius: 10px;
      background: linear-gradient(90deg, #f5fafc, #fcfbfa);
      display: flex;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;
      .name {
        font-size: 16px;
      }
      .shu {
        width: 1px;
        height: 13px;
        margin: 0 10px;
        background-color: #ebebeb;
      }
      .money {
        font-size: 20px;
        font-weight: 600;
        color: #f3160e;
      }
    }
    .contBox {
      height: calc(100% - 315px);
      overflow: auto;
      padding: 20px 30px;
      .cont {
        display: flex;
        flex-direction: column;
        align-items: self-start;
        margin-bottom: 15px;
        .bBox {
          display: flex;
          .hong {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            color: #fff;
            background-color: #d31811;
            margin-right: 10px;
            margin-top: 10px;
            font-size: 12px;
            font-weight: 600;
          }
        }
        .jlCont {
          border-radius: 5px;
          border: 1px solid #8cc2f5;
          width: 250px;
          height: 120px;
          background: linear-gradient(to bottom, #c5e3ff, #fff);
          padding: 15px;
          box-sizing: border-box;
          .jlBox {
            display: flex;
            align-items: center;
            .icon {
              height: 45px;
              width: 45px;
              border-radius: 5px;
              background-color: #2287e6;
              color: #fff;
              font-size: 28px;
              margin-right: 10px;
            }
          }
          .jlBtn {
            height: 30px;
            border-radius: 5px;
            background-color: #c5e3ff;
            margin-top: 15px;
            cursor: pointer;
          }
        }
        .box {
          background-color: #167edf;
          color: #fff;
          border-radius: 10px;
          padding: 10px;
        }
        .time {
          padding: 5px 10px;
          font-size: 12px;
          color: #9c9c9c;
        }
        .boxl {
          border-top-left-radius: 0;
        }
        .boxr {
          border-top-right-radius: 0;
        }
        .img {
          width: 40%;
          cursor: pointer;
        }
      }
      .contr {
        align-items: flex-end;
      }
    }
    .contBtn {
      height: 200px;
      border-top: 1px solid #ebebeb;
      .box {
        display: flex;
        align-items: center;
        padding: 0 30px;
        height: 55px;
        .picture {
          font-size: 28px;
          color: #666;
          cursor: pointer;
        }
        .shu {
          width: 1px;
          height: 16px;
          margin: 0 20px;
          background-color: #ebebeb;
        }
        .textBox {
          border: 1px solid #dfdfdf;
          height: 24px;
          padding: 0 10px;
          border-radius: 5px;
          font-size: 12px;
          margin-right: 15px;
          cursor: pointer;
        }
      }
      .cont {
        height: calc(100% - 105px);
        box-sizing: border-box;
        padding: 0 30px;
        textarea {
          width: 100%;
          height: 100%;
          border: none;
          resize: none;
        }
      }
      .funBox {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 30px;
        color: #c9c9c9;
        .btn {
          border-radius: 5px;
          width: 60px;
          margin-left: 15px;
          height: 30px;
          font-size: 13px;
          border: 1px solid #ebebeb;
          color: #cfcccc;
          box-sizing: border-box;
        }
        .on {
          animation: 0.5s both biantan;
        }
        @keyframes biantan {
          100% {
            border: 1px solid #ebebeb;
            background-color: #fff;
            color: #cfcccc;
          }
          100% {
            border: 1px solid #147ee0;
            background-color: #147ee0;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
